import React from "react";
import { cn } from "../ui";

/**
 * The brand's square mark on the auth screens' dark surfaces (the desktop panel
 * and the phone band). Takes `useBrandMark()`'s output:
 *
 *   icon        → the institute's favicon / logo
 *   no icon     → its initial on the brand fill, so the slot never looks broken
 *   pending     → an empty tile of the same size, so nothing jumps when the
 *                 brand arrives — and nothing of ours is shown in the meantime
 */
const SIZES = {
  md: "tw-h-9 tw-w-9 tw-text-base",
  lg: "tw-h-11 tw-w-11 tw-text-lg",
};

const AuthBrandMark = ({ mark, size = "lg", className }) => {
  const box = cn("tw-shrink-0 tw-rounded-md", SIZES[size] || SIZES.lg, className);

  if (mark.icon) {
    return <img src={mark.icon} alt="" className={cn(box, "tw-object-contain")} />;
  }
  if (mark.pending || !mark.initial) {
    return <span aria-hidden="true" className={cn(box, "tw-block tw-bg-on-surface-dark/10")} />;
  }
  return (
    <span
      aria-hidden="true"
      className={cn(
        box,
        "tw-inline-flex tw-items-center tw-justify-center tw-bg-primary-solid tw-font-bold tw-text-primary-solid-fg"
      )}
    >
      {mark.initial}
    </span>
  );
};

export default AuthBrandMark;
